import { Link } from "react-router-dom";

const FaqContent = () => {
  return (
    <>
      <h2 className="header faq__header">FAQ</h2>

      <div className="faq">
        <div className="question">
          <h3>W jakim terminie organizowany jest obóz?</h3>
          <p>Obóz organizowany jest w terminie 03.07 - 13.07.2027 r.</p>
        </div>
        <div className="question">
          <h3>Kto może być uczestnikiem obozu?</h3>
          <p>
            Uczestnikami obozu mogą być uczniowie po IV klasie Szkoły
            Podstawowej. Wymagana jest opinia wychowawcy, a także opinia
            nauczyciela matematyki (w przypadku uczniów po IV klasie SP) oraz
            fizyki (po VII kl. SP), a w przypadku wybrania programu
            biologia/chemia opinia nauczycieli tych przedmiotów.
          </p>
        </div>
        <div className="question">
          <h3>Kto jest organizatorem obozu?</h3>
          <p>
            Osada Wiedzy opiera się na pracy wykwalifikowanych nauczycieli, z
            bogatym dorobkiem zawodowym, mających uprawnienia w zakresie
            trenerskim, pracujących i koordynujących obozy naukowe od 2010r.
            Dzięki pracownikom Uniwersytetu Gdańskiego i Uniwersytetu Morskiego
            uczniowie będą mogli korzystać bezpośrednio z wiedzy naukowców.
            Więcej informacji w zakładce „Zespół”
            https://www.osadawiedzy.pl/zespol
          </p>
        </div>
        <div className="question">
          <h3>Co obejmuje cena obozu?</h3>
          <p>
            Cena obozu obejmuje: koszty zakwaterowania (noclegu), wyżywienia,
            ubezpieczenia NNW, koszty gadżetów (koszulka krój uniwersalny,
            długopis, zeszyt, bidon na wodę), atrakcje dodatkowe: udział w
            spływie kajakowym (jeden spływ).
          </p>
        </div>
        <div className="question">
          <h3>Do kiedy należy opłacić obóz?</h3>
          <p>
            W dniu zawarcia umowy rodzic/opiekun prawny wpłaca kwotę 30% ceny
            obozu tytułem opłaty rezerwacyjnej. Na 21 dni przed planowanym
            terminem rozpoczęcia obozu tj. do dnia 13.06.2026r. ( w przypadku I
            terminu obozu) 24.06.2026r. (w przypadku II terminu obozu)
            rodzic/opiekun prawny zobowiązuje się uiścić na rzecz Organizatora
            pozostałą część opłaty za obóz.
          </p>
        </div>
        <div className="question">
          <h3>Gdzie i kiedy organizowany jest obóz?</h3>
          <p>
            Obóz naukowy organizowany jest w Załakowie. Miejscowość leży w
            województwie pomorskim w pobliżu Lęborka i Sierakowic. Właśnie w
            Załakowie, powstało Centrum wypoczynkowe „Na Gwizdówce”. Położenie z
            dala od zabudowań mieszkalnych sprawia, że uczestnicy mogą liczyć na
            ciszę, spokój i wypoczynek. Kompleks wypoczynkowy powstał w 2014
            roku i wykonany został z najwyższą starannością i dbałością o
            szczegóły. Otoczenie obiektu dopasowane jest do leśnego krajobrazu
            okolic jeziora Świętego. Uczestnicy obozu zostaną zakwaterowani w
            hotelu. Zajęcia odbywać się będą w budynku obok kompleksu
            hotelowego.
          </p>
          <a href="http://www.gwizdowka.pl/">http://www.gwizdowka.pl/</a>
        </div>
        <div className="question">
          <h3>Jakie są warunki zakwaterowania uczestników?</h3>
          <p>
            Uczestnicy zakwaterowani są w budynku hotelowym głównie w pokojach 2
            lub 3-osobowych z dostępem do prywatnej łazienki w każdym pokoju,
            dodatkowo jest 1 pokój 4- osobowy typu studio. (2+2) i 1 pokój
            5-osobowy także typu studio (2+3), każde studio ma także dostęp do
            prywatnej łazienki. Jeśli dwóch lub więcej uczestników chce być w
            jednym pokoju proszę o wpisanie tego w kwestionariuszu zgłoszenia w
            punkcie: <bold>Inne uwagi o uczestniku, komentarz</bold>
          </p>
        </div>

        <div className="question">
          <h3>Czy jest możliwość skorzystania ze specjalnej diety?</h3>
          <p>
            Tak, możliwość wyboru diety znajduje się w kwestionariuszu
            zgłoszenia.
          </p>
        </div>
        <div className="question">
          <h3>Co uczestnik zabiera ze sobą na obóz?</h3>
          <p>
            Uczestnicy zabierają ze sobą: długopisy, ołówki, linijki. Zeszyty
            będą czekały na miejscu. Dodatkowo oczywiście obowiązkowo należy
            zabrać stroje kąpielowe, spodenki, buty do biegania, ponieważ poza
            nauką będziemy się troszkę ruszać. Karty do gry i różne gry logiczne
            również się przydadzą. Jeżeli dziecko uczestniczy w programie
            matematyka/fizyka/programowanie zabiera ze sobą laptopa z systemem
            operacyjnym Windows 10 lub 11.
          </p>
        </div>
        <div className="question">
          <h3>Jak zaczynamy każdy dzień?</h3>
          <p>
            Każdy dzień zaczynamy zaprawą poranną o godzinie 7:30, która jest
            <bold> obowiązkowa</bold> dla wszystkich uczestników. Jeśli istnieją
            przeciwskazania medyczne do wykonywania przez dziecko wybranych
            ćwiczeń, prosimy uwzględnienie tego w kwestionariuszu zgłoszenia w
            punkcie: <bold>Istotne dane o stanie zdrowia uczestnika</bold>.
          </p>
        </div>
        <div className="question">
          <h3>Jakie są możliwości transportu na obóz?</h3>
          <p>
            Na ten moment nie organizujemy transportu na obóz, rodzic/opiekun
            prawny przywozi i odbiera dziecko osobiście. W przypadku, gdy rodzic
            bądź opiekun prawny nie może osobiście odebrać dziecka prosimy o
            przekazanie upoważnienia osobie odbierającej.
          </p>
        </div>
        <div className="question">
          <h3>Co zrobić jeśli w kwestionariuszu popełniłem/am błąd?</h3>
          <p>
            Prosimy o kontakt na adres e-mail:{" "}
            <a href="mailto:kontakt@osadawiedzy.pl">kontakt@osadawiedzy.pl</a>
          </p>
        </div>
        <div className="question">
          <h3>Jakie dokumenty uczestnicy zabierają ze sobą na obóz?</h3>
          <p>
            Uczestnicy nie potrzebują zabierać żadnych dokumentów tożsamości.
            Dane uczestników podają Państwo wypełniając kwestionariusz
            zgłoszenia.
          </p>
        </div>
        <div className="question">
          <h3>Czy uczestnicy objęci są dodatkowym ubezpieczeniem?</h3>
          <p>Tak, uczestnicy ubezpieczeni są grupowym ubezpieczeniem NNW.</p>
        </div>
        <div className="question">
          <h3>Jaki jest podział uczestników na grupy?</h3>
          <p>
            Uczestnicy podzieli są na grupy względem klasy, którą ukończyli w
            szkole. Dopuszcza się możliwość (szczególnie w starszych grupach)
            uczestniczenia w zajęciach na innym poziomie. Podziału na grupy
            dokonujemy w pierwszym dniu obozu.
          </p>
        </div>
        <div className="question">
          <h3>Czym jest program dla dzieci?</h3>
          <p>
            Jest to program skierowany do uczniów po IV klasie do VI klasy
            szkoły podstawowej. Zajęcia realizowane są w ramach matematyki oraz
            nauk przyrodniczych, które obejmują elementy biologii, fizyki i
            chemii. Program ma charakter wprowadzający i odkrywczy – nie wymaga
            zaawansowanego aparatu matematycznego ani wiedzy podręcznikowej, a
            jego celem jest rozbudzenie ciekawości poznawczej i zainteresowania
            naukami przyrodniczymi. Zajęcia prowadzone są w formie problemowej,
            doświadczeń i obserwacji, dostosowanych do wieku i etapu
            edukacyjnego uczestników.{" "}
            <bold>
              Ponadto dzieci uczestniczą w zajęciach z zakresu kompetencji
              społecznych.
            </bold>
          </p>
        </div>
        <div className="question">
          <h3>
            Czym jest program dla młodzieży – matematyka/fizyka/programowanie?
          </h3>
          <p>
            Jest to program skierowany dla uczniów po VII klasie szkoły
            podstawowej. Zajęcia odbywają się z fizyki, matematyki i
            programowania. Zajęcia obejmują zagadnienia wykraczające poza
            program nauczania, który dziecko zrealizowało w ramach nauki tego
            przedmiotu w szkole w klasie, którą ukończyło. <br />
            <br />
            Ponadto dzieci uczestniczą w zajęciach z zakresu kompetencji
            społecznych.
          </p>
        </div>
        <div className="question">
          <h3>Czym jest program maturalny – fizyka?</h3>
          <p>
            Jest to program skierowany do uczniów klasy III LO lub IV technikum,
            którzy chcą wybrać studia techniczne i maturę z fizyki. Kurs
            umożliwi uczniom podjęcie decyzji maturalnej i ułatwi przygotowania
            do czekającej matury z fizyki. Zajęcia prowadzone są przez
            egzaminatora maturalnego. <br />
            <br />
            <bold>
              Ponadto młodzież uczestniczy w zajęciach z zakresu kompetencji
              społecznych.
            </bold>
          </p>
        </div>
        <div className="question">
          <h3>Czym jest program maturalny chemia/biologia?</h3>
          <p>
            Jest to program skierowany do uczniów szkół średnich, którzy chcą
            przygotować się do matury z biologii lub chemii. <br />
            <br />
            <bold>
              Ponadto młodzież uczestniczy w zajęciach z zakresu kompetencji
              społecznych.
            </bold>
          </p>
        </div>
        <div className="question">
          <h3>Czym są kody polecające i jak działają?</h3>
          <p>
            Po zapisaniu się na obóz każdy uczestnik otrzymuje indywidualny,
            prywatny kod polecający. Jeżeli podczas rejestracji na obóz inna
            osoba wpisze ten kod, uczestnik, który go udostępnił, otrzymuje
            zniżkę w wysokości 50 zł na swój turnus.
          </p>
        </div>
        <div className="question">
          <h3>Czy z kodu polecającego można skorzystać więcej niż raz?</h3>
          <p>
            Tak. Liczba użyć jednego kodu polecającego nie jest ograniczona.
            Każde prawidłowe użycie kodu przez inną osobę skutkuje przyznaniem
            kolejnej zniżki w wysokości 50 zł. Łączna kwota uzyskanych zniżek
            zostaje odliczona od całkowitego kosztu obozu.
          </p>
        </div>
        <div className="question">
          <h3>Czy kody polecające łączą się ze zniżką dla rodzeństwa?</h3>
          <p>
            Program kodów polecających nie łączy się ze zniżkami dla rodzeństwa
            (150 zł na drugie dziecko oraz 300 zł na każde kolejne). Oznacza to,
            że wpisanie kodu polecającego uzyskanego przy zapisie pierwszego
            dziecka nie powoduje naliczenia zniżki przy zapisywaniu drugiego lub
            kolejnego dziecka.
          </p>
        </div>
        <div className="question">
          <h3>Kogo można zapisać z wykorzystaniem kodu polecającego?</h3>
          <p>
            Kody polecające działają w przypadku polecania obozu osobom, które
            nie były wcześniej uczestnikami obozów Osady Wiedzy.
          </p>
        </div>
        <div className="question">
          <h3>Czy poza wakacjami organizowane są zajęcia?</h3>
          <p>
            Tak, zachęcamy do zapoznania się z Naszą ofertą zajęcia{" "}
            <Link to="/nauki-scisle-po-godzinach">
              "Nauki ścisłe po godzinach"
            </Link>
          </p>
        </div>
        <div className="question">
          <h3>Jakie są zasady korzystania z telefonów komórkowych?</h3>
          <p>
            Nie zabieramy uczestnikom telefonów komórkowych, chyba, że wyraźnie
            zostanie to zaznaczone przez rodzica. Program dnia jest niezwykle
            obszerny, co sprawia, że uczestnicy mają bardzo niewiele czasu w
            ciągu dnia na korzystanie z urządzeń elektronicznych. Czas wolny
            uczestników w przerwie obiadowej oraz wieczorem jest także
            zorganizowany.
          </p>
        </div>
        <div className="question">
          <h3>Jakie zachowania uczestników skutkują usunięciem z obozu?</h3>
          <p>
            W trakcie trwania obozu obowiązuje zakaz posiadania i używania przez
            uczestników obozu narkotyków, środków odurzających, środków
            psychotropowych, dopalaczy oraz środków o zbliżonym działaniu, jak
            również obowiązuje zakaz używania alkoholu i tytoniu oraz
            e-papierosów (papierosy elektroniczne).{" "}
            <bold>
              W przypadku naruszenia tego punktu regulaminu uczestnik zostaje
              usunięty z obozu
            </bold>
            .
          </p>
        </div>
        <div className="question">
          <h3>Spływ kajakowy</h3>
          <p>
            Ostatniego dnia obozu tj. <bold>13.07.2027r.</bold> organizowany
            jest spływ kajakowy. Tego dnia nie ma żadnych zajęć edukacyjnych.
            Spływ kajakowy dla uczestnika wliczony jest w cenę obozu. Istnieje
            możliwość (do której zachęcamy) dołączenia do spływu
            (rodzice/opiekunowie prawni, rodzeństwo, rodzina, znajomi), wówczas
            prosimy o kontakt (może być mailowy).
            <br />
            <br />
            Na spływ ruszamy z ośrodka autokarem około 8-9 rano i po spływie tam
            wracamy, więc samochody można zostawić na terenie ośrodka. Po
            spływie na wszystkich uczestników czeka kolacja - grill na terenie
            ośrodka. Pływamy okolicznymi rzekami, około 6h. Koszt spływu
            kajakowego z transportem i kolacją zostanie podana zainteresowanym
            na 21 dni przed planowanym terminem obozu, natomiast trasa spływu
            zostanie ostatecznie ustalona 7 dni przed planowanym terminem spływu
            (związane jest to z zachowaniem bezpieczeństwa oraz ustaleniem stanu
            wody na rzece). Zachęcamy do udziału w spływie, nawet jeżeli nigdy
            jeszcze nie pływaliście kajakami :).
          </p>
        </div>
        <div className="question">
          <h3>Faktury</h3>
          <p>
            <ol>
              <li>
                Na prośbę rodzica/prawnego opiekuna, po wskazaniu danych w
                kwestionariuszu zapisu istnieje możliwość wystawienia faktury.
              </li>
              <li>
                Jeśli potrzebują Państwo faktury, a nie zostało to wpisane w
                kwestionariuszu zapisu, prosimy o kontakt na adres e-mail{" "}
                <bold>kontakt@osadawiedzy.pl</bold> podając dane do faktury.
              </li>
              <li>
                Standardowo w tytule faktury wpisujemy „Udział imię i nazwisko
                dziecka w obozie naukowym Osada Wiedzy w dniach od (data
                rozpoczęcia obozu) do (data zakończenia obozu) w którym bierze
                udział dziecko”.
              </li>
              <li>
                Faktura wystawiana jest na osobę dorosłą - rodzica lub prawnego
                opiekuna dziecka. Podczas zgłoszenia prosimy o wskazanie danych
                osoby, na którą ma zostać wystawiona faktura.
              </li>
              <li>
                Uprzejmie informujemy, że po wystawieniu faktury nie ma
                możliwości zmiany jej danych, treści ani tytułu, zgodnie z
                obowiązującymi przepisami oraz funkcjonowaniem Krajowego Systemu
                e-Faktur (KSeF).
              </li>
              <li>
                W przypadku potrzeby zastosowania innego zapisu na fakturze (np.
                niestandardowego tytułu lub szczególnych danych), prosimy o
                kontakt przed dokonaniem płatności i wystawieniem faktury pod
                adresem e-mail: <bold>kontakt@osadawiedzy.pl</bold>. Zgłoszenia
                przesłane po wystawieniu faktury nie będą mogły zostać
                uwzględnione.
              </li>
            </ol>
          </p>
        </div>
      </div>
    </>
  );
};
export default FaqContent;
